import { gql } from "@apollo/client";

export const GET_TIRESET = gql(`
    query Tireset($id: ID!) {
        tiresets(id: $id) {
            data {
                id
                type
                sleep_set
                in_hotel
                tire_rim
                comment
                position {
                    id
                }
                tires {
                    id
                    label
                    brand
                    brand_type
                    type
                    ean
                    profile_depth
                    size
                    run_flat
                    car_position
                    status
                }
                car {
                    id
                    licence
                    label
                    freestock_tire
                    relation {
                      id
                    }
                    customer {
                        id
                    }
                }
                storedLatestRequest {
                  id
                  source_type
                  source_id
                  type
                  invoice_status
                  pickup_and_delivery_date
                  state
                  stateFlow {
                      completed
                      refused
                      cancelled
                      value
                      type
                  }
                  invoiced
                  work_order_number
                  availableTransitions
                  created_at
                  relation {
                    id
                    name
                  }
                  user {
                    id
                  }
                }
                requests {
                  id
                  state
                  requestTires {
                      id
                      tire {
                          car_position
                      }
                  }
                }
                getPickupDeliveryDates {
                  firstDate
                  forbiddenDates
                }
            }
        }
    }
`);
